import React from 'react';

const VRLanding = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">VR/AR Learning</h1>
      <p className="text-gray-600">VR features coming soon...</p>
    </div>
  );
};

export default VRLanding;